<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
//import axios from 'axios';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
//import { fetchAverageRemainingStock } from '@/api/api.js';

const colors = [
  'rgba(75, 192, 192, 1)',
  //'rgba(54, 162, 235, 1)',
  //'rgba(255, 206, 86, 1)',
  //'rgba(255, 99, 132, 1)',
  'rgba(153, 102, 255, 1)'
];

const options = {
  responsive: true,
  maintainAspectRatio: true,
  tooltips: {
    enabled: false,
    custom: CustomTooltips,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
      }
    }
  },
  legend: {
    display: true,
    labels: {
      fontSize: 10, // 원하는 크기로 설정
      generateLabels: function(chart) {
        const data = chart.data;
        return data.datasets.map((dataset, i) => ({
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          strokeStyle: dataset.borderColor,
          lineWidth: 2,
          hidden: !chart.isDatasetVisible(i),
          index: i
        }));
      }
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        color: 'rgba(0, 0, 0, 0.1)'
      },
      ticks: {
        fontColor: '#000',
        fontSize: 9
      }
    }],
    yAxes: [{
      gridLines: {
        color: 'rgba(0, 0, 0, 0.1)'
      },
      ticks: {
        fontColor: '#000',
        fontSize: 9,
        beginAtZero: true
      }
    }]
  },
  elements: {
    line: {
      tension: 0.4 // Global default tension for all datasets
    },
    point: {
      radius: 2,
      hoverRadius: 4,
      backgroundColor: function (context) {
        return context.dataset.borderColor;
      }
    }
  }
};

export default {
  name: 'LineChart1',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, options);
  },
  watch: {
    chartData(newVal) {
      const updateData = {
        labels: newVal.labels,
        datasets: newVal.datasets.map((dataset, index) => ({
          ...dataset,
          backgroundColor: 'transparent',
          borderColor: colors[index % colors.length],
          pointBackgroundColor: colors[index % colors.length],
          borderWidth: 1,
          tension: 0.4
        }))
      };
      this.renderChart(updateData, options);
    }
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 50%;
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
